import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { AuthProvider } from './contexts/AuthContext';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Auto-refresh page when Invisible reCAPTCHA throws "Cannot read properties of null (reading 'style')" error
window.addEventListener('error', (event) => {
  const msg = event.message || '';
  const src = event.filename || '';
  if (
    msg.includes("Cannot read properties of null (reading 'style')") &&
    (src.includes('recaptcha') || src.includes('gstatic.com'))
  ) {
    // Reload page to reset reCAPTCHA state
    window.location.reload();
  }
});
